import { Loading } from 'element-ui';
var globalMask = null

const open = () => {
  globalMask = Loading.service({
    lock: true,
    text: `请稍后。。。`,
    spinner: "el-icon-loading",
    background: 'rgba(0, 0, 0, 0.5)',
  })
}

const close = () => {
  if (globalMask) {
    globalMask.close()
  }
}

export default {
  open,
  close
}
